import { parseLocalDate, toIsoDate } from '@/shared/i18n/dateUtils';
import { admits } from './admits';
import { DateRules, DateSpan } from './rules';

export function eligibleDayCount(rules: DateRules, notBefore?: string): number {
  const span = bookableSpan(rules, notBefore);
  if (!span) return 0;

  let count = 0;
  for (let date = span.from; date <= span.to; date = nextDay(date)) {
    if (admits(rules, date)) count += 1;
  }

  return count;
}

function bookableSpan(rules: DateRules, notBefore?: string): DateSpan | null {
  if (rules.accept.length === 0) return null;

  const [first, ...rest] = rules.accept;
  let earliest = first.from;
  let to = first.to;

  for (const window of rest) {
    if (window.from < earliest) earliest = window.from;
    if (window.to > to) to = window.to;
  }

  const from = notBefore && notBefore > earliest ? notBefore : earliest;

  return from > to ? null : { from, to };
}

function nextDay(date: string): string {
  const parsed = parseLocalDate(date);
  parsed.setDate(parsed.getDate() + 1);

  return toIsoDate(parsed);
}
